// Compact "From → To" row for the current leg, with an optional trailing label (e.g. stop index).
import React from "react";
import { Box, Stack, Typography } from "@mui/material";
import ArrowRightAltIcon from "@mui/icons-material/ArrowRightAlt";
import PropTypes from "prop-types";
import { tokens } from "../../theme";

const StopInfoStrip = ({ from = "Base", to, trailingLabel, trailingValue }) => (
  <Stack
    direction="row"
    alignItems="center"
    gap={1.25}
    sx={{
      p: 1.5,
      background: tokens.surface2,
      border: `1px solid ${tokens.border}`,
      borderRadius: "11px",
    }}
  >
    <Box sx={{ minWidth: 0 }}>
      <Typography
        sx={{ fontSize: 10, fontWeight: 700, letterSpacing: "0.06em", color: tokens.text3 }}
      >
        FROM
      </Typography>
      <Typography sx={{ fontSize: 13, fontWeight: 600, color: tokens.text, mt: 0.2 }} noWrap>
        {from}
      </Typography>
    </Box>
    <ArrowRightAltIcon sx={{ color: tokens.borderStrong, flexShrink: 0 }} />
    <Box sx={{ minWidth: 0, flex: 1 }}>
      <Typography
        sx={{ fontSize: 10, fontWeight: 700, letterSpacing: "0.06em", color: tokens.text3 }}
      >
        TO
      </Typography>
      <Typography sx={{ fontSize: 13, fontWeight: 600, color: tokens.text, mt: 0.2 }} noWrap>
        {to || "—"}
      </Typography>
    </Box>
    {trailingLabel && (
      <Box sx={{ textAlign: "right", flexShrink: 0 }}>
        <Typography
          sx={{ fontSize: 10, fontWeight: 700, letterSpacing: "0.06em", color: tokens.text3 }}
        >
          {trailingLabel}
        </Typography>
        <Typography sx={{ fontSize: 13, fontWeight: 600, color: tokens.text, mt: 0.2 }}>
          {trailingValue}
        </Typography>
      </Box>
    )}
  </Stack>
);

StopInfoStrip.propTypes = {
  from: PropTypes.string,
  to: PropTypes.string,
  trailingLabel: PropTypes.string,
  trailingValue: PropTypes.node,
};

export default StopInfoStrip;
